import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { Select, SelectValue } from 'tdesign-react';

import { EditorAddFore, EditorAddImage, RemoveFore } from '@/components/icon';
import { ALERT_IMAGE } from '@/const/form';
import { ActionType, ChangeMediaOperationType, ChangeMediaType, EventType } from '@/const/mission';
import { ImageRatio } from '@/const/richMedia';
import { IEvents, StoryLayout } from '@/interface';
import { ImageDomType, RichMediaValue } from '@/interface/media';
import UploadPic from '@/material/form-upload/image';

import styles from '../index.module.less';

interface IProps {
  contentEventIdColWidth: number | undefined;
  value: IEvents;
  disabled: boolean;
  isHorizontal?: boolean;
  onChange: (value: any) => void;
}

const ImageItem: React.FC<IProps> = (props) => {
  const { value, onChange, disabled, isHorizontal = false } = props;
  const isFore = value?.action?.changeMedia?.type === ChangeMediaType.CHANGE_MEDIA_TYPE_FOREGROUND_IMAGE;

  const handleChange = (data: RichMediaValue) => {
    const imgData = isFore ? { foregroundImage: data } : { backgroundImage: data };
    const postData: IEvents = {
      type: EventType.EVENT_TYPE_ACTION,
      action: {
        type: ActionType.ACTION_TYPE_CHANGEMEDIA,
        changeMedia: {
          ...value?.action?.changeMedia,
          type: value?.action?.changeMedia?.type || ChangeMediaType.CHANGE_MEDIA_TYPE_BACKGROUND_IMAGE,
          ...imgData,
          operation: ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_MODIFY,
        },
      },
    };
    onChange(postData);
  };

  const operation = value?.action?.changeMedia?.operation;
  const isRemove = operation === ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_REMOVE;

  const handleChangeSelect = (data: SelectValue) => {
    let postData = {
      type: EventType.EVENT_TYPE_ACTION,
      action: {
        type: ActionType.ACTION_TYPE_CHANGEMEDIA,
        changeMedia: {
          ...value?.action?.changeMedia,
        },
      },
    };
    const isRemoveSelect = data === ChangeMediaType.REMOVE_BG_IMAGE || data === ChangeMediaType.REMOVE_FORE_IMAGE;
    if (isRemoveSelect) {
      const type = data === ChangeMediaType.REMOVE_BG_IMAGE
        ? ChangeMediaType.CHANGE_MEDIA_TYPE_BACKGROUND_IMAGE
        : ChangeMediaType.CHANGE_MEDIA_TYPE_FOREGROUND_IMAGE;
      let tmpData = { ...value?.action?.changeMedia };
      if (type === ChangeMediaType.CHANGE_MEDIA_TYPE_BACKGROUND_IMAGE) {
        tmpData = {
          backgroundImage: {
            url: { url: '' },
          },
        };
      } else {
        tmpData = {
          foregroundImage: {
            url: { url: '' },
          },
        };
      }
      postData = {
        type: EventType.EVENT_TYPE_ACTION,
        action: {
          type: ActionType.ACTION_TYPE_CHANGEMEDIA,
          changeMedia: {
            type,
            operation: ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_REMOVE,
            ...tmpData,

          },
        },
      };
    } else {
      postData = {
        type: EventType.EVENT_TYPE_ACTION,
        action: {
          type: ActionType.ACTION_TYPE_CHANGEMEDIA,
          changeMedia: {
            ...value?.action?.changeMedia,
            type: data as ChangeMediaType,
            operation: ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_MODIFY,
          },
        },
      };
    }
    onChange(postData);
  };

  const getOption = () => [
    { label: '单人立绘', value: ChangeMediaType.CHANGE_MEDIA_TYPE_FOREGROUND_IMAGE },
    { label: '移除立绘', value: ChangeMediaType.REMOVE_FORE_IMAGE },
    // { label: '新增背景图', value: ChangeMediaType.CHANGE_MEDIA_TYPE_BACKGROUND_IMAGE },
    // { label: '移除背景图', value: ChangeMediaType.REMOVE_BG_IMAGE },
  ];

  const removeValue = isFore ? ChangeMediaType.REMOVE_FORE_IMAGE : ChangeMediaType.REMOVE_BG_IMAGE;

  const removeCname = isFore ? '移除立绘' : '移除背景图';

  const getImgValue = () => (isFore
    ? value?.action?.changeMedia?.foregroundImage
    : value?.action?.changeMedia?.backgroundImage);

  const getSelValue = () => (isRemove ? removeValue : value?.action?.changeMedia?.type);

  const getOptions = () => (isRemove ? getOption() : getOption() || []);

  const [selectValue, setSelectValue] = useState(getSelValue());
  const [imageValue, setImageValue] = useState(getImgValue());
  const [options, setOptions] = useState(getOptions());

  useEffect(() => {
    setSelectValue(getSelValue());
    setImageValue(getImgValue());
    setOptions(getOptions());
  }, [value]);

  const uiOptions = {
    isShowRichMedia: true,
    maxCount: 1,
    dialogConfig: {
      width: 370,
      height: 700,
    },
    width: 152,
    height: 270,
    contentStyle: { width: '100%', maxWidth: 'auto' },
    isHorizontal,
    limit: { ratio: isHorizontal ? ImageRatio['812:375'] : ImageRatio['9:16'] },
    alertRender: isHorizontal
      ? ALERT_IMAGE[StoryLayout.LAYOUT_HORIZONTAL]
      : ALERT_IMAGE[StoryLayout.LAYOUT_VERTICAL],
  };

  return (
    <div className={styles.itemBox}>
      {isFore
        ? <div className={classNames(styles.system, styles.leftType, styles.noPadding, 'draggable')}>
          <Select
            prefixIcon={<div className={styles.selectPreIcon}>
              {selectValue === ChangeMediaType.REMOVE_FORE_IMAGE
                ? <RemoveFore />
                : <EditorAddFore />}
            </div>}
            className={styles.botSelect}
            value={selectValue}
            onChange={handleChangeSelect}
            options={options}
            disabled={disabled}
            defaultValue={options?.[0]?.value}
          />
        </div>
        : <div className={classNames(styles.system, styles.leftType, 'draggable')}>
          <EditorAddImage />
          <span className={styles.label}>背景图</span>
        </div>}
      <div className={styles.contentBox}>
        {isRemove
          ? <div className={classNames(styles.pauseAudio, 'draggable', {
            ['nova-disabled-opacity']: disabled,
            ['nova-disabled']: disabled,
          })}>
            <span>{removeCname}</span>
          </div>
          : <UploadPic
            onChange={data => handleChange(data as RichMediaValue)}
            asyncUploadOnChange={data => handleChange(data as RichMediaValue)}
            value={{ ...imageValue }}
            className={styles.flex1}
            {...uiOptions as any}
            hasEditBtn={false}
            disabled={isRemove || disabled}
            domType={ImageDomType.MISSION}
          />
        }
      </div>
    </div>
  );
};

export default ImageItem;
